import React, { useMemo } from 'react';
import { Marker } from '@/components/GoogleMap';
import { onwardNavy, white } from '@/styles/colors';

/*
 * The pin dropped on the centre of the approximate-facility circle (ENG-9599).
 *
 * A local variant rather than DispatchPlan's shared `PickUp`: that icon's viewBox is flush with the
 * artwork (`0 0 27 33`), so a drop shadow drawn inside it is clipped at the edges, and its anchor is
 * hardcoded to the unpadded geometry. Padding the viewBox here keeps the shadow intact and leaves
 * the planning map's markers untouched.
 *
 * Navy body rather than green or white: green is the customer's own Home pin, and a white pin all
 * but vanishes against a light map washed with the circle's green fill.
 */

// Artwork sits at 0 0 27 33 with its tip at (12.7, 33); PAD widens the canvas around it so the
// shadow has somewhere to fall.
const PAD = 5;
const TIP = { x: 12.7, y: 33 };

const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${27 + PAD * 2}" height="${
    33 + PAD * 2
}" viewBox="${-PAD} ${-PAD} ${27 + PAD * 2} ${33 + PAD * 2}">
    <filter id="pin-shadow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#000000" flood-opacity="0.35"/>
    </filter>
    <g filter="url(#pin-shadow)">
        <path d="M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z" fill="${onwardNavy}"/>
        <path d="M6 13.4L10 13.4L10 19L16 19L16 13.4L20 13.4L13 6.86667L6 13.4Z" fill="${white.primary}"/>
    </g>
</svg>`;

const FACILITY_PIN_URL = `data:image/svg+xml,${encodeURIComponent(svg)}`;

const FacilityMarker = ({ position, ...props }) => {
    const icon = useMemo(
        () => ({
            url: FACILITY_PIN_URL,
            anchor: new window.google.maps.Point(TIP.x + PAD, TIP.y + PAD),
        }),
        []
    );

    return <Marker position={position} icon={icon} {...props} />;
};

export default FacilityMarker;
